import { OnboardingTrialStepsType } from '@sdk/authentication/types';
import type { UserFromApi } from '@sdk/users/types/UserFromApi';
import type { OrgSettings } from '@sdk/authentication/types/OrganisationType';
import type { GroupType } from '@sdk/groups/types/GroupType';
import type { LocationType } from '@sdk/locations/types/LocationType';
import type { PositionType } from '@sdk/positions/types/PositionType';
import type { BaseWagesFromApi, PositionWagesFromApi } from '@sdk/labor/types/apiTypes';

export type OnboardingStepsConfigType = {
  [key in OnboardingTrialStepsType]?: { content: string; action: () => void };
};

export type OnboardingSingleStepConfig = {
  key: OnboardingTrialStepsType;
  content: string;
  action: () => void;
};

export type AddPersonaCollectionUser = (props: { user: UserFromApi }) => void;

export type OpenCreateShiftModal = () => void;
export type NavigateToSchedule = (pops: { date: string }) => void;
export type NavigateToReports = () => void;
export type UpdateOrgSettings = (props: { settings: OrgSettings }) => void;
export type EditPersonaCollectionGroup = (props: {
  group: LocationType | GroupType | PositionType;
}) => void;
export type ShowPublishShiftModal = () => void;
export type ShowPublishShiftTooltip = () => void;
export type LoadLaborCostData = () => Promise<void>;
export type UpdateWages = (props: { wages: BaseWagesFromApi[] | PositionWagesFromApi[] }) => void;

export enum EventStatus {
  published = 'published',
  planning = 'planning',
}

export type Event = {
  type: 'shift';
  status: EventStatus;
  dtstart: Date;
};
